import script from "./pharmacist.vue?vue&type=script&setup=true&lang=js"
export * from "./pharmacist.vue?vue&type=script&setup=true&lang=js"

import "./pharmacist.vue?vue&type=style&index=0&id=7eab694b&lang=css"

const __exports__ = script;

export default __exports__